import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "priceing" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "first-column-with-icon-type" }
const _hoisted_7 = { class: "name-type-block" }
const _hoisted_8 = { class: "type-data-block" }
const _hoisted_9 = { class: "type-data-block" }
const _hoisted_10 = { class: "type-data" }
const _hoisted_11 = { class: "emq-table-footer" }

import { getActivityList, upsertActivity } from '@/api/operation'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { ArrowDown, ArrowUp, Refresh, RefreshLeft, Search, Plus } from '@element-plus/icons-vue'
import { pick } from 'lodash'
import ShowEnumActivityState from '@/components/ShowEnumActivityState.vue'
import { dateFormat, throttleBtn } from '@/common/tools'
import ActivityDrawer from './components/ActivityDrawer.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { checkMenuShow } from '@/store/tool'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import LinkOperator from '@/components/Links/LinkOperator.vue'

import { defineComponent, ref, PropType } from 'vue'

const __default__ = defineComponent({
  name: 'Activity',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t, tl } = useI18nTl('Operation')
const { getActivityTypeDesc } = useProtocolEnums()

const showDialog = ref(false)
const editFlag = ref(false)
const showInfo = ref({ tmpl: { amountType: 0, items: [] } })
const showMoreQuery = ref(false)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({})

const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('operators-detail')
const ActivityDrawerRef = ref()
const addActivity = () => {
  editFlag.value = false
  showDialog.value = true
  // showInfo.value = {}
  ActivityDrawerRef.value?.clearValidate()
}
const editActivity = (row: any) => {
  editFlag.value = true
  showInfo.value = row
  showDialog.value = true
}

const handleSearch = async () => {
  params.value = genQueryParams(fuzzyParams.value)
  loadDatas()
}

const handleReset = () => {
  fuzzyParams.value = {}
  handleSearch()
}

const onIsOpenChange = async (row: any) => {
  try {
    await upsertActivity({
      id: row.id,
      isOpen: row.isOpen,
    })
    if (!row.isOpen) {
      ElMessage.success(t('Base.disabledSuccess'))
    } else {
      ElMessage.success(t('Base.enableSuccess'))
    }
    // ElMessage.success(t('Base.opSuccess'))
  } catch (error) {
    console.log(error)
  }
}

const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const { id, ver, operatorID } = params
  newParams = {
    id: id || undefined,
    ver: ver || undefined,
    operatorID: operatorID || undefined,
  }
  return newParams
}

const loadDatas = async () => {
  lockTable.value = true
  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
    },
  }

  try {
    const { list = [], pageReply = {} } = await getActivityList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}
const loadDatasRefreshLimit = throttleBtn(loadDatas, 1000)
loadDatas()

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_button, {
          type: "primary",
          icon: _unref(Plus),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (addActivity()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.create')), 1)
          ]),
          _: 1
        }, 8, ["icon"]),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: _unref(loadDatasRefreshLimit)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon", "onClick"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "id",
            "min-width": "80",
            fixed: "",
            label: _ctx.$t('Base.name'),
            "show-overflow-tooltip": "",
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_tooltip, {
                placement: "top",
                content: row.id
              }, {
                default: _withCtx(() => [
                  (_unref(checkMenuShow)('activityUpsert'))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        onClick: ($event: any) => (editActivity(row)),
                        type: "text"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(row.name), 1))
                ]),
                _: 2
              }, 1032, ["content"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "operatorName",
            "min-width": "80",
            label: _ctx.$t('Operation.operator')
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(LinkOperator, {
                id: row.operatorId,
                name: row.operatorName
              }, null, 8, ["id", "name"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "type",
            "min-width": "120",
            label: _ctx.$t('Operation.activityType')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", null, _toDisplayString(_unref(getActivityTypeDesc)(row.type)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "chargingbeginTime",
            "min-width": "100",
            label: _ctx.$t('Order.chargingRangeTime')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(dateFormat)(Number(row.beginTime) * 1000)), 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(dateFormat)(Number(row.endTime) * 1000)), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "state",
            "min-width": "80",
            label: _ctx.$t('Base.state')
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(ShowEnumActivityState, {
                state: row.state
              }, null, 8, ["state"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "isEnabled",
            "min-width": "80",
            label: _ctx.$t('Base.isEnabled')
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_switch, {
                class: "enable-btn",
                disabled: !_ctx.$hasPermission('post'),
                modelValue: row.isOpen,
                "onUpdate:modelValue": ($event: any) => ((row.isOpen) = $event),
                onChange: ($event: any) => (onIsOpenChange(row))
              }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "create",
            "min-width": "100",
            label: _ctx.$t('Base.create')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(dateFormat)(Number(row.createdAt) * 1000)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Base.operation'),
            "class-name": "table-operation"
          }, {
            default: _withCtx(({ row }) => [
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (editActivity(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.edit')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'priceingUpsert']
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[1] || (_cache[1] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadDatas
        }, null, 8, ["metaData"])
      ]),
      _createVNode(ActivityDrawer, {
        ref_key: "ActivityDrawerRef",
        ref: ActivityDrawerRef,
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showDialog).value = $event)),
        isEdit: editFlag.value,
        info: showInfo.value,
        onSubmitted: loadDatas
      }, null, 8, ["modelValue", "isEdit", "info"])
    ])
  ]))
}
}

})